module.exports = __webpack_public_path__ + "img/vission.28a2a0e2.png";